module.exports = __webpack_public_path__ + "img/Ellipse 116.bb383c52.png";